"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeoContract = void 0;
const consts_1 = require("../../consts");
const ContractParam_1 = require("../ContractParam");
const manifest_1 = require("../manifest");
const Nep17Contract_1 = require("./Nep17Contract");
const NeoTemplateAbi_json_1 = __importDefault(require("./templates/NeoTemplateAbi.json"));
let SINGLETON;
class NeoContract extends Nep17Contract_1.Nep17Contract {
    static get INSTANCE() {
        if (!SINGLETON) {
            SINGLETON = new NeoContract();
        }
        return SINGLETON;
    }
    /**
     * The list of methods found on the NEO contract.
     */
    static getMethods() {
        return NeoTemplateAbi_json_1.default.methods.map((m) => manifest_1.ContractMethodDefinition.fromJson(m));
    }
    constructor() {
        super(consts_1.NATIVE_CONTRACT_HASH.NeoToken, NeoContract.getMethods());
    }
    unclaimedGas(address, end) {
        return this.call("unclaimedGas", ContractParam_1.ContractParam.hash160(address), ContractParam_1.ContractParam.integer(end));
    }
    getCandidates() {
        return this.call("getCandidates");
    }
    getRegisterPrice() {
        return this.call("getRegisterPrice");
    }
    registerCandidate(publicKey) {
        return this.call("registerCandidate", ContractParam_1.ContractParam.publicKey(publicKey));
    }
    vote(address, voteTo) {
        return this.call("vote", ContractParam_1.ContractParam.hash160(address), ContractParam_1.ContractParam.publicKey(voteTo));
    }
}
exports.NeoContract = NeoContract;
